import React from 'react';

const ErrorMessage = (props) => {

    if (props.valid) {
        return null;
    }

    return (
        <span style={props.style} className='text-danger ms-2'>
            {props.error}
        </span>
    );
};

ErrorMessage.displayName = 'ErrorMessage';

export default ErrorMessage;
